import { signupPageStyles } from '../../../pages/signup/SignupPage/SignupPage.styles';

export const signupDistrictAdminStyles = {
  page: signupPageStyles.page,
  content: signupPageStyles.content,
  form: signupPageStyles.form,
  productForm: signupPageStyles.productForm,
};
